import React, { useMemo } from "react";
import { AGREGADO, IGUAL, QUITADO, calcularDiferencias } from "./diferenciasTexto";

const CONTEXTO = 80;

const abreviar = (texto, esPrimero, esUltimo) => {
  if (texto.length <= CONTEXTO * 2 + 20) return texto;
  if (esPrimero) return `… ${texto.slice(-CONTEXTO)}`;
  if (esUltimo) return `${texto.slice(0, CONTEXTO)} …`;
  return `${texto.slice(0, CONTEXTO)} … ${texto.slice(-CONTEXTO)}`;
};

export const RevisionDiferencias = ({ original, corregido, titulo = "Parte corregida" }) => {
  const tramos = useMemo(() => calcularDiferencias(original, corregido), [original, corregido]);

  if (!tramos.some((t) => t.tipo !== IGUAL)) return null;

  return (
    <div className="citrus-ia-diferencias">
      <span className="citrus-ia-diferencias__titulo">{titulo}</span>
      <p className="citrus-ia-diferencias__texto">
        {tramos.map((tramo, indice) => {
          if (tramo.tipo === QUITADO) {
            return <del key={indice} title="Estaba mal">{tramo.texto}</del>;
          }
          if (tramo.tipo === AGREGADO) {
            return <ins key={indice} title="Corrección">{tramo.texto}</ins>;
          }
          return <span key={indice}>{abreviar(tramo.texto, indice === 0, indice === tramos.length - 1)}</span>;
        })}
      </p>
      <span className="citrus-ia-diferencias__leyenda">
        <del>Tachado</del>: lo que estaba mal · <ins>Resaltado</ins>: la corrección
      </span>
    </div>
  );
};
